import Axios from "axios";

export async function get_event_list(props) {
	const branch_id = props["branch_id"];
	const Set_eventList = props["Set_eventList"];
	const isMounted = props["isMounted"];

	const result = await Axios
                    .post("/consumer/event/load", {
                        branch_id: branch_id,
                    });
	const data = result["data"];

    if(data['status'] === 'fail') {
        alert(data['message'])
    }
    else if(data['status'] === 'success') {
        await Set_eventList(data['data']);

        if(isMounted) {
            isMounted.current++;
        }
    }
}
